import { ScheduleTimeZoneFilter } from '@/components/ui/features/schedule/ScheduleTimeZoneFilter/ScheduleTimeZoneFilter';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TimezoneText } from './elements';

export const TimeZoneLabel: FC = ({ ...rest }) => {
  const { t } = useTranslation();

  return (
    <TimezoneText {...rest}>
      {t('scheduleEntries.timeZone')}
      <ScheduleTimeZoneFilter />
    </TimezoneText>
  );
};
